<template>
  <div class="upload-file-wrapper">
    <div class="company-identification-wrapper">
      <div v-if="organization.active" class="sender-pic">
        <org-image :organization='organization' :propStyle="{ width: '80px', height: '80px', 'line-height': '80px' }" class="org-pic" />
      </div>
      <div v-else class="sender-pic">
        <user-image :user='creator' :propStyle="{ width: '80px', height: '80px', 'line-height': '80px' }" />
      </div>

      <div v-if="nonCurrentRecords.length">
        <p>
          {{ $t('public.see_email')}}
        </p>

        <a target="false" href="https://support.relatico.com/en/article/someone-emailed-me-requesting-a-new-file-version-1w5qtqf/">
          {{ $t('public.how_it_works')}}
        </a>

        <div class="new-version-upload">
          <h1>
            {{ $t('versions.expiration.upload_files')}}
          </h1>
          <ol>
            <li v-for='record in nonCurrentRecords' :key='record.id'>
              <h5>{{ record.filename }}</h5>
              <form @submit.prevent='replaceRecord(record, $event)'>
                <fieldset>
                  <input type='file' name='file' />
                  <input type='submit' class='btn btn-primary btn-sm' value="Upload" />
                  <a v-if="record.revalidation_interval > 0"  href="#" @click.prevent='stillValid(record)' class='btn btn-neutral btn-sm'>{{ $t('versions.expiration.still_valid')}}</a>
                  <a href="#" @click.prevent='noFile(record)' class='btn btn-neutral btn-sm'>{{ $t('versions.expiration.no_file')}}</a>
                </fieldset>
              </form>
            </li>
          </ol>
        </div>
      </div>
      <div v-else>
        <p>
          <strong>{{ $t('public.thank_you')}}</strong>
        </p>
      </div>
    </div>

  </div>
</template>

<script>
  import Uppy from '@uppy/core'
  import XHRUpload from '@uppy/xhr-upload'

  import _user_image from '../../components/_user_image'
  import _org_image from '../../components/_org_image'

  export default {
    components: {
      'user-image': _user_image,
      'org-image': _org_image,
    },
    created() {
      this.store.sendMetrics({name: 'public_expiration_page', params: this.$route.params, path: this.$route.fullPath})
      if(this.isIE()) {
        this.$router.push({ name: 'unsupported_browser' })
      }

      this.uppy = Uppy()
      this.uppy.use(XHRUpload, {
        endpoint: `${this.baseApiUrl}/inline/upload`,
        method: 'post',
        formData: true,
        fieldName: 'file',
        limit: 1,
        withCredentials: true,
        headers: {
          'Client-ID': process.env.VUE_APP_FRONTEND_CLIENT_ID
        },
        getResponseData (responseText, response) {
          return JSON.parse(responseText)
        }
      }).setMeta({ prefix: 'records/' })


      this.store.getPublicExpirationPage(this.$route.params.uuid)
    },
    data() {
      return {
        uppy: null,
        resolved: {}
      }
    },
    computed: {
      folderUUID() {
        return this.$route.params.uuid
      },
      expirationPage() {
        return this.state.expirationPage || {}
      },
      records() {
        return this.expirationPage.records || []
      },
      nonCurrentRecords() {
        return this.records.filter(({id, next_record_id, status}) => {
          return !next_record_id && (status == 'expired' || status == 'soon' || status == 'current') && !this.resolved[id]
        })
      },
      organization(){
        return this.expirationPage.organization || {}
      },
      creator(){
        return this.expirationPage.creator || {}
      }
    },
    methods: {
      loadFolder() {
        return this.store.getPublicExpirationPage(this.folderUUID)
      },
      replaceRecord(record, e) {
        const file = new FormData(e.target).get('file')

        if (!file || file.size == 0) {
          this.$toastr.alert(this.$t('record.upload_new_version.select_file'))
          return
        }

        this.uppy.addFile({
          source: 'file input',
          name: file.name,
          type: file.type,
          data: file
        })

        this.uppy.upload().then(({successful}) => {
          this.resolved = Object.assign({}, this.resolved, { [record.id]: true })

          successful.forEach(({uploadURL}) => {
            const params = Object.assign({}, {
              folder_id: record.folder_id,
              filename: file.name,
              mime_type: file.type,
              size: file.size,
              location: uploadURL,
              contact_id: this.expirationPage.contact_id
            })

            this.store.publicReplaceRecord(record, params)
            this.store.sendMetrics({name: 'replace_file_from_public_page', params: this.$route.params, path: this.$route.fullPath})
          })
        })
      },
      noFile(record) {
        const params = Object.assign({}, { contact_id: this.expirationPage.contact_id })
        this.resolved = Object.assign({}, this.resolved, { [record.id]: true })

        this.store.noReplacementForRecord(record, params)
        this.store.sendMetrics({name: 'no_replace_file_from_public_page', params: this.$route.params, path: this.$route.fullPath})

      },
      stillValid(record) {
        const params = Object.assign({}, { contact_id: this.expirationPage.contact_id })
        this.resolved = Object.assign({}, this.resolved, { [record.id]: true })

        this.store.markRecordAsStillValid(record, params)
        this.store.sendMetrics({name: 'still_valid_file_from_public_page', params: this.$route.params, path: this.$route.fullPath})

      },
      isIE() {
        let ua = navigator.userAgent
        return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "../../styles/upload_page"
</style>
